import { useState } from "react";
import styles from "./../styles.module.css";
import {
  MetaAplicacao,
  MetaFisica,
} from "../../../../model/PlanoDeTrabalho/CronogramaExecucao";
import Modal from "react-responsive-modal";
import Table from "../../../../components/TableConstructor";
import RowAplicacao from "../../../../components/TableConstructor/Row/RowAplicacao";
import ModalMetaAplicacao from "../../../../components/ModalForms/ModalMetaAplicacao";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  aplicacoesCorrente: MetaAplicacao[];
  setAppCorrente: React.Dispatch<React.SetStateAction<MetaAplicacao[]>>;
  aplicacoesCapital: MetaAplicacao[];
  setAppCapital: React.Dispatch<React.SetStateAction<MetaAplicacao[]>>;
  listaMetas: MetaFisica[];
};

function CronogramaAplicacao({
  passarPagina,
  voltarPagina,
  aplicacoesCorrente,
  setAppCorrente,
  aplicacoesCapital,
  setAppCapital,
  listaMetas,
}: Props) {
  const [showModelCorrente, setModelCorrente] = useState(false);
  const [showModelCapital, setModelCapital] = useState(false);
  const [showEditModelCorrente, setEditModalCorrente] = useState(-1);
  const [showEditModelCapital, setEditModalCapital] = useState(-1);
  return (
    <div>
      <h2 className={styles.titulo}>
        2.2. Descreva o <strong>Cronograma</strong> de Aplicação Financeira :
      </h2>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Corrente:</h3>
      <div>
        <Table
          listTitle={[
            "Meta",
            "Especificação - CORRENTE",
            "Órgão/Entidade ",
            "OSC",
            "",
          ]}
          styleList={[1, 0, 1, 1, 0]}
        >
          {aplicacoesCorrente.map((appObj, index) => (
            <RowAplicacao
              appObj={appObj}
              key={index}
              metaFisica={listaMetas[appObj.meta_execucao_fisico_id]}
            >
              <button
                className={styles.btn}
                onClick={(e) => {
                  e.preventDefault();
                  setEditModalCorrente(index);
                }}
              >
                Editar
              </button>
              <Modal
                open={showEditModelCorrente === index}
                onClose={() => setEditModalCorrente(-1)}
                center
                classNames={{
                  modal: "customModal",
                }}
              >
                <ModalMetaAplicacao
                  refMeta={appObj}
                  closeModal={() => setEditModalCorrente(-1)}
                  list={aplicacoesCorrente}
                  setList={setAppCorrente}
                  listaMetas={listaMetas}
                  index={index}
                  tipo="corrente"
                />
              </Modal>
            </RowAplicacao>
          ))}
        </Table>
        <div className={styles.addDiv}>
          <button
            className={styles.addBtn}
            onClick={(e) => {
              e.preventDefault();
              setModelCorrente(true);
            }}
          >
            + Adicionar Meta
          </button>
        </div>
        <Modal
          open={showModelCorrente}
          onClose={() => setModelCorrente(false)}
          center
          classNames={{
            modal: "customModal",
          }}
        >
          <ModalMetaAplicacao
            closeModal={() => setModelCorrente(false)}
            list={aplicacoesCorrente}
            setList={setAppCorrente}
            listaMetas={listaMetas}
            tipo="corrente"
          />
        </Modal>
      </div>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Capital:</h3>
      <div>
        <Table
          listTitle={[
            "Meta",
            "Especificação - CAPITAL",
            "Órgão/Entidade",
            "OSC",
            "",
          ]}
          styleList={[1, 0, 1, 1, 0]}
        >
          {aplicacoesCapital.map((appObj, index) => (
            <RowAplicacao
              appObj={appObj}
              key={index}
              metaFisica={listaMetas[appObj.meta_execucao_fisico_id]}
            >
              <button
                className={styles.btn}
                onClick={(e) => {
                  e.preventDefault();
                  setEditModalCapital(index);
                }}
              >
                Editar
              </button>
              <Modal
                open={showEditModelCapital === index}
                onClose={() => setEditModalCapital(-1)}
                center
                classNames={{
                  modal: "customModal",
                }}
              >
                <ModalMetaAplicacao
                  refMeta={appObj}
                  closeModal={() => setEditModalCapital(-1)}
                  list={aplicacoesCapital}
                  setList={setAppCapital}
                  listaMetas={listaMetas}
                  index={index}
                  tipo="capital"
                />
              </Modal>
            </RowAplicacao>
          ))}
        </Table>
        <div className={styles.addDiv}>
          <button
            className={styles.addBtn}
            onClick={(e) => {
              e.preventDefault();
              setModelCapital(true);
            }}
          >
            + Adicionar Meta
          </button>
        </div>
      </div>
      <Modal
        open={showModelCapital}
        onClose={() => setModelCapital(false)}
        center
        classNames={{
          modal: "customModal",
        }}
      >
        <ModalMetaAplicacao
          closeModal={() => setModelCapital(false)}
          list={aplicacoesCapital}
          setList={setAppCapital}
          listaMetas={listaMetas}
          tipo="capital"
        />
      </Modal>
      <hr className={styles.separador} />
      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default CronogramaAplicacao;
